var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 6.5C7.14499 6.5 4.89006 10.2726 4.09708 12.0534C3.96927 12.3405 3.96927 12.6595 4.09708 12.9466C4.89006 14.7274 7.14499 18.5 12.0002 18.5C16.8555 18.5 19.1103 14.7273 19.9031 12.9465C20.0309 12.6595 20.0309 12.3405 19.9031 12.0535C19.1103 10.2727 16.8555 6.5 12.0002 6.5ZM2.27002 11.2399C3.13935 9.28756 5.89147 4.5 12.0002 4.5C18.1091 4.5 20.861 9.28782 21.7302 11.2401C22.0885 12.0448 22.0885 12.9552 21.7302 13.7599C20.861 15.7122 18.1091 20.5 12.0002 20.5C5.89147 20.5 3.13935 15.7124 2.27002 13.7601C1.91162 12.9552 1.91162 12.0448 2.27002 11.2399Z",
    fill: "#436A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.5C9.79086 8.5 8 10.2909 8 12.5C8 14.7091 9.79086 16.5 12 16.5C14.2091 16.5 16 14.7091 16 12.5C16 10.2909 14.2091 8.5 12 8.5ZM11.9153 10.5018C11.9434 10.5006 11.9716 10.5 12 10.5C13.1046 10.5 14 11.3954 14 12.5C14 13.6046 13.1046 14.5 12 14.5C10.8954 14.5 10 13.6046 10 12.5C10 12.4716 10.0006 12.4434 10.0018 12.4153C10.1577 12.4701 10.3253 12.5 10.5 12.5C11.3284 12.5 12 11.8284 12 11C12 10.8253 11.9701 10.6577 11.9153 10.5018Z",
    fill: "#436A7A"
  })));
}
export default SvgVisibility;